var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInboxOutlined = function SvgInboxOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".inbox-outlined_svg__path{stroke:currentColor}")), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.25a1.25 1.25 0 0 1 1.25 1.25v10a1.25 1.25 0 0 1-1.25 1.25H7.518a2.5 2.5 0 0 0-1.768.733l-2.5 2.5V4.5A1.25 1.25 0 0 1 4.5 3.25h15ZM4.5 2A2.5 2.5 0 0 0 2 4.5v15.991a.625.625 0 0 0 1.067.442l3.567-3.567A1.25 1.25 0 0 1 7.517 17H19.5a2.5 2.5 0 0 0 2.5-2.5v-10A2.5 2.5 0 0 0 19.5 2h-15Z",
    style: {
      fill: "currentColor"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M7 7.5h10M9 11.5h6",
    className: "inbox-outlined_svg__path"
  })));
};
export default SvgInboxOutlined;